import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { AvantoModalControlService } from 'src/app/services/avanto-modalControl.service';
import { AvantoSessionService } from 'src/app/services/avanto-session.service';
import { AvantoRoutingService } from 'src/app/services/avanto-routing.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-cart-modal',
  templateUrl: './cart-modal.component.html',
  styleUrls: ['./cart-modal.component.scss']
})
export class CartModalComponent implements OnInit, OnDestroy {
  
  isCartSidebarOpen:boolean;
  selectedRestaurantName:string;
  selectedRestaurantId:string;
  cartSubtotal:number;
  cartModalStatusOpenSubscription:Subscription;
  sessionSubscription:Subscription;

  isOneRestaurantMode:boolean;

  cartItems = 0;


  constructor(private renderer: Renderer2, private modal:AvantoModalControlService, private session:AvantoSessionService, private avantoRoute:AvantoRoutingService) { }

  ngOnInit() {
    //Initial status
    this.isCartSidebarOpen = false;
    // Everytime somebody wants to open/close the 
    this.cartModalStatusOpenSubscription = this.modal.toggleCartSidebarSubject.subscribe(status=>{
      status?this.openNav():this.closeNav();
    });
    this.sessionSubscription = this.session.sessionSubject.subscribe(session=>{
      this.selectedRestaurantName = session.restaurantInformation.title;
      this.cartItems = session.cart.cartItems.size;
      this.selectedRestaurantId = session.restaurantInformation.restaurantId;
      this.cartSubtotal = session.cart.subtotal;
      this.isOneRestaurantMode = session.isOneRestaurantMode;
    })
  }

  ngOnDestroy(){
    this.cartModalStatusOpenSubscription.unsubscribe();
    this.sessionSubscription.unsubscribe();
  }

  goToRestaurantPage(){
    const restaurantIdSplit = this.selectedRestaurantId.split('.');
    if(this.isOneRestaurantMode){
      this.avantoRoute.goToOneRestaurantModeChooseFoodPage(restaurantIdSplit[0],restaurantIdSplit[1])
    }else{
      this.avantoRoute.goToChooseFoodPage(restaurantIdSplit[0],restaurantIdSplit[1])
    }
  }

  openNav() {
    this.isCartSidebarOpen = true;
    //When we open the cart sidebar, we hide the scroll option for the BODY of the page.
    //I did this so we don't have 2 scroll bars showing (one for the page and the other for the cart)
    this.renderer.addClass(document.body, 'overflow-hidden');
  }

  closeNav() {
    this.isCartSidebarOpen = false;
    //When we close the cart sidebar, we un-hide the scroll option for the BODY of the page.
    //Go read openNav() for more details.
    this.renderer.removeClass(document.body, 'overflow-hidden');
  }
  
  clickCheckoutBtn() {
    this.avantoRoute.goToCheckoutPage();
  }
}
